bovoApp.controller('CarrierReportController', ['$scope', '$rootScope', '$filter', '$routeParams', 'Analytic', 'CustomerGroup',
  function ($scope, $rootScope, $filter, $routeParams, Analytic, CustomerGroup) {
    $scope.loading = true;
    $scope.data = [];
    $scope.reportType = 'carrierPerformance';

    // Date picker options
    $scope.opts = {
      locale: {
        applyLabel: 'Uygula',
        cancelLabel: 'İptal',
        customRangeLabel: 'Özel Aralık',
        daysOfWeek: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
        monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
        firstDay: 1
      },
      ranges: {
        'Bu Ay': [moment().startOf('month'), moment().endOf('month')],
        'Geçen Ay': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Son 3 Ay': [moment().subtract(2, 'month').startOf('month'), moment().endOf('month')],
        'Son 6 Ay': [moment().subtract(5, 'month').startOf('month'), moment().endOf('month')]
      },
      opens: 'left'
    };

    $scope.filterData = {
      customers: [],
      workers: [],
      workSteps: [],
      page: 1,
      cargo_date: {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
      },
      type: $routeParams.type
    }

    $scope.refreshData = function () {
      if ($scope.reportType == 'carrierPerformance') {
        $scope.carrierPerformance()
      }
      if ($scope.reportType == 'carrierPerformanceCityDistrict') {
        $scope.carrierPerformanceCityDistrict()
      }
    };

    $scope.carrierPerformance = function () {
      $scope.loading = true;
      Analytic.dashboard($scope.filterData).then(function (response) {
        $scope.data = response.data.data;
        $scope.loading = false;
      }, function (error) {
        console.error('Error loading carrier report data:', error);
        $scope.loading = false;
      });
    };

    $scope.carrierPerformanceCityDistrict = function () {
      $scope.loading = true;
      Analytic.carrierPerformanceCityDistrict($scope.filterData).then(function (response) {
        $scope.data = response.data.data;
        $scope.loading = false;
      }, function (error) {
        console.error('Error loading carrier report data:', error);
        $scope.loading = false;
      });
    };

    // Get customer groups for filtering
    $scope.getCustomerGroups = function () {
      CustomerGroup.all().then(function (response) {
        $scope.filterCustomerGroups = response.data;
      });
    };

    // Get customers for filtering
    $scope.getCustomers = function () {
      Analytic.customers().then(function (response) {
        $scope.filterCustomers = response.data;
      });
    };

    // Clear all filters
    $scope.clearFilter = function () {
      $scope.filterData = {
        customers: [],
        customer_groups: [],
        workers: [],
        workSteps: [],
        page: 1,
        cargo_date: {
          startDate: moment().startOf('month'),
          endDate: moment().endOf('month'),
        },
        type: $routeParams.type
      };
      $('.selectpicker').selectpicker('refresh');
      $scope.refreshData();
    };

    // Check if a route is active
    $scope.isActive = function (route) {
      return $rootScope.currentRoute === route;
    };

    // Watch for changes in report type
    $scope.$watch('reportType', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        $scope.refreshData();
      }
    });
  }
]);